// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import SettleLawsuitPrimaryHeadNode from "./SettleLawsuitPrimaryHeadNode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitPrimaryHeadCheck extends BaseComponent {

	@property({ type: cc.Toggle, displayName:'' })
	toggle: cc.Toggle = null;

    private csvInfo: any = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

        this.initUI();
    }

    initUI() {
        let id = this._carryData.id;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_PEOPLE, id);
        if (!this.csvInfo) {
            console.error(`未找到头像数据`);
            return;
        }

        let headScript = cc.find('SettleLawsuitPrimaryHeadNode', this.node).getComponent(SettleLawsuitPrimaryHeadNode);
        headScript.setCarryData({
            id: id
        });
    }

    onClick() {
        // O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._carryData.parent.onClickSelect(this._carryData.idx);
    }

    onClickToggle(toggle: cc.Toggle) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (!toggle.isChecked) {
            toggle.check();
            return;
        }
        this._carryData.parent.selectPeople(this._carryData.idx);
    }

    setToggleEnable(enable: boolean) {
        this.toggle.interactable = enable;
    }

    onUnselect() {
        this.toggle.uncheck();
    }

    onSelect() {
        if (!this.toggle.isChecked) {
            this.toggle.check();
        }
    }

    getLevel() {
        return Number(this.csvInfo.level);
    }
    // update (dt) {}
}
